import React from 'react';

function About() {
  return <div>
      <h1>Resume Builder App</h1>
      <p style={{marginBottom: '15px'}}>v1.0.2</p>
      <hr />
      <p>This is a web application where you can build your resume with some simple clicks. This app is owned by <b>Xit Bangladesh Corporation</b>. Built by <b>Md. Abtahi Tajwar</b>. </p>
  </div>;
}

export default About;
